<template>
  <div class="centered-box mx-auto mx-lg-0 mx-xl-auto">
    <v-img :src="require('@/modules/Layout/assets/logo.svg')" :width="logoWidth" class="mx-auto mb-12" contain />
    <div v-if="title" class="text-h4 pt-3 pb-6">{{ title }}</div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
  },
  computed: {
    logoWidth() {
      return this.$vuetify.breakpoint.lgAndUp ? 270 : 180;
    },
  },
};
</script>

<style lang="scss" scoped>
.centered-box {
  max-width: 450px;
}
</style>
